module.exports = __webpack_public_path__ + "img/extended.7a999c8d.png";